import { common } from '@mui/material/colors'
import shadows from '@mui/material/styles/shadows'

export const defaultInputStyle = {
  boxShadow: shadows[1],
  backgroundColor: common.white,
  borderColor: 'transparent',
  borderRadius: '4px',
}

export const GREY_100_TAILWIND = '#f3f4f6'
export const GREY_300_TAILWIND = '#d1d5db'
export const GREY_500_TAILWIND = '#6b7280'
export const ROUNDED_MD = '0.375rem'
export const ROUNDED_XL = '0.75rem'
export const SHADOWS_TAILWIND = '0 0 #0000, 0 0 #0000, 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
export const SHADOWS_TOP_AND_BOTTOM_TAILWIND =
  '0 0 #0000, 0 0 #0000, 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06), 0 -4px 6px -1px rgba(0, 0, 0, 0.1), 0 -2px 4px -1px rgba(0, 0, 0, 0.06)'
export const GREEN_700_TAILWIND = '#15803D'
export const RED_900_TAILWIND = '#7F1D1D'

export const DEFAULT_FONT_FAMILY = 'Manrope'
export const DEFAULT_PRIMARY_COLOR = '#0055A4'
export const DEFAULT_BACKGROUND_SEARCH_COLOR = '#F1F5F8'
export const DEFAULT_WELCOME_TEXT_COLOR = '#FFFFFF'

declare module '@mui/material/styles' {
  interface Palette {
    welcomeTextColor: Palette['primary']
    backgroundSearchColor: Palette['primary']
  }
  interface PaletteOptions {
    welcomeTextColor?: PaletteOptions['primary']
    backgroundSearchColor?: PaletteOptions['primary']
  }
}
